"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function strictEncodeUriComponent(uri) {
    // encodeURIComponent does not remove all reserved chars
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
    return encodeURIComponent(uri).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`);
}
exports.default = strictEncodeUriComponent;
